export const invoicesdb = [
    { value: '01', label: 'Factura' },
    { value: '03', label: 'Crédito Fiscal' },
    //{ value: '03', label: 'Comprobante de Crédito Fiscal' },
    //{ value: '06', label: 'Nota de Débito' },
    { value: '11', label: 'Facturas de exportación' },
    { value: "14", label: "Sujeto excluido", id: 12}
    //{ value: '14', label: 'Sujeto excluido' },
  ]